'use client';

import { useRef } from 'react';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../core/Tracking/Amplitude/Amplitude';
import { HomePageDocument } from '../../../../resources/homePageDocument/domain/types/homePageDocument';
import { useTrackBlockViewed } from '../../../../shared/hooks/useTrackBlockViewed';

import { ReasonsToBelieveCard } from './ReasonsToBelieveCard/ReasonsToBelieveCard';
import style from './ReasonsToBelieveSection.module.css';

type ReasonsToBelieveSectionProps = {
    reasonsToBelieve: HomePageDocument['reasonsToBelieve'];
};

export function ReasonsToBelieveSection({ reasonsToBelieve }: ReasonsToBelieveSectionProps) {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();
    const sectionRef = useRef<HTMLDivElement>(null);

    useTrackBlockViewed(sectionRef, 'rtb');

    return (
        <section className="bg-beige-100">
            <div ref={sectionRef} className={style.container}>
                <h2 className={style.title}>
                    {formatMessage(
                        { id: 'page.home.reasonsToBelieve.title' },
                        {
                            em: (chunks) => {
                                return (
                                    <em
                                        key={`title-emphasis-${String(chunks)}`}
                                        className={style.titleEmphasis}
                                    >
                                        {chunks}
                                    </em>
                                );
                            },
                        },
                    )}
                </h2>
                <div className={style.scrollableContainer}>
                    {reasonsToBelieve.map((reasonToBelieve, index) => {
                        return (
                            <ReasonsToBelieveCard
                                key={index + 1}
                                title={reasonToBelieve.title}
                                subtitle={reasonToBelieve.subtitle}
                                description={reasonToBelieve.description}
                                onClick={({ isFlipped }) => {
                                    trackEvent((ampli, defaultProperties) => {
                                        ampli.rtbClicked({
                                            ...defaultProperties,
                                            block: 'rtb',
                                            card_number: index + 1,
                                            is_flipped: isFlipped,
                                        });
                                    });
                                }}
                            />
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
